import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import BaseButton from "@/components-UI/BaseButton.vue";
import SvgMagicWand from "@/assets/icons/magic-wand.svg";
import SvgEdit from "@/assets/icons/edit-pen.svg";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { ITableHeader, showServerError } from "@/utils";
import { CellsType, RawConfig, prepareItems } from "@/utils/CellsFactory";
import { getUserDepartments, postUserDepartment, patchUserDepartment } from "@/api/user";
import { IServerResponse } from "@/api/types";
import { IDepartment } from "@/api/types/user";
import FormModal from "@/components/base/FormModal.vue";
import BaseInput from "@/components-UI/BaseInput.vue";
import BaseAutocomplete from "@/components-UI/BaseAutocomplete.vue";
import { getUserSearch } from "@/api/user";
import SvgCheck from "@/assets/icons/check.svg";

type IDepartmentExtra = IDepartment & { toggle: boolean, actions: unknown };


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDepartments',
  setup(__props) {

const headers: ITableHeader[] = [
    { text: 'ID отдела', value: 'id', width: '100px', align: 'center' },
    { text: 'Название', value: 'name', width: 'auto' },
    { text: 'Руководитель', value: 'leader', width: 'auto' },
    { text: '', value: 'actions', width: '50px', align: 'center' },
];
const config: RawConfig<IDepartmentExtra> = {
    [CellsType.Uniq]: {
        name: {},
        leader: {},
        actions: {},
    },
};
const tableItems = ref<IDepartmentExtra[]>([]);
const tableLoading = ref<boolean>(false);
const showCreateModal = ref<boolean>(false);
const modalForm = ref<{ name: string, leader_id: number | null }>({
    name: '',
    leader_id: null,
});

const getTableItems = computed(() =>
    prepareItems(tableItems.value, config, headers.map(h => h.value)),
);

const openModal = (): void => {
    showCreateModal.value = true;
    modalForm.value = { name: '', leader_id: null };
};

const editDepartment = async (item: IDepartmentExtra): Promise<void> => {
    try {
        if (!item.toggle) {
            item.toggle = true;
            return;
        }

        tableLoading.value = true;
        item.toggle = false;

        await patchUserDepartment(item.id, { name: item.name, leader_id: item.leader.account_id });
        await fetchUserDepartments();
    } catch (e) {
        showServerError(e, 'Не удалось отредактировать отдел');
    } finally {
        tableLoading.value = false;
    }
};

const saveAndCloseModal = async (): Promise<void> => {
    try {
        tableLoading.value = true;

        await postUserDepartment(modalForm.value);
        await fetchUserDepartments();

        showCreateModal.value = false;
    } catch (e) {
        showServerError(e, 'Не удалось создать отдел.');
    } finally {
        tableLoading.value = false;
    }
};

const fetchUserDepartments = async (): Promise<void> => {
    try {
        tableLoading.value = true;

        const resp: IServerResponse<IDepartment[]> = await getUserDepartments();
        tableItems.value = resp.data.map(el => ({
            ...el,
            ...{ toggle: false },
        }));
    } catch (e) {
        showServerError(e, 'Список отделов не получен.');
    } finally {
        tableLoading.value = false;
    }
};

onMounted(async () => {
    await fetchUserDepartments();
});

return { __sfc: true,headers, config, tableItems, tableLoading, showCreateModal, modalForm, getTableItems, openModal, editDepartment, saveAndCloseModal, fetchUserDepartments, PageLayout, BaseButton, SvgMagicWand, SvgEdit, BaseTable, FormModal, BaseInput, BaseAutocomplete, getUserSearch, SvgCheck }
}

})